import styled from 'styled-components'

const SocialLink = styled.a`
  margin-right: 1rem;
`

export default SocialLink
